export default __webpack_public_path__ + "static/media/about-img.5e04ed55.jpg";